import { parse, stringify } from 'flatted';
import { getLocalStorage } from './createPrefixedLocalStorage';

const produzioneLocalStorageKey = 'documenti_produzione';
const templateLocalStorageKey = 'templates';

const setDocumenti = (userId: string, studioId?: string) => {
    const prefixedStorage = getLocalStorage();

    const key = getKeyByUserAndStudio(userId, studioId);
    if (!prefixedStorage.getItem(key)) {
        prefixedStorage.setItem(key, stringify([]));
    }
};

const overrideDocumenti = (
    registroDocumenti: string[],
    userId: string,
    studioId: string,
) => {
    const prefixedStorage = getLocalStorage();

    const key = getKeyByUserAndStudio(userId, studioId);
    prefixedStorage.setItem(key, stringify(registroDocumenti));
};

export const rimuoviDocumentoProduzione = (
    documento: any,
    userId: string,
    studioId: string,
    isTemplate: boolean,
    rimuoviDaLista: boolean = true,
) => {
    const prefixedStorage = getLocalStorage();

    prefixedStorage.removeItem(documento.uuid);
    if (rimuoviDaLista) {
        const documentiProduzione = getDocumenti(userId, studioId, isTemplate);
        // @ts-ignore
        const nuoviDocumenti = documentiProduzione.filter((item) => item !== documento.uuid,);
        const key = getKeyByUserAndStudio(userId, studioId);
        prefixedStorage.setItem(key, stringify(nuoviDocumenti));
    }
};
//modifica
const getDocumenti = (
    userId: string,
    studioId?: string,
    isTemplate: boolean = false,
) => {
    const prefixedStorage = getLocalStorage();

    const key = getKeyByUserAndStudio(userId, studioId, isTemplate);
    const localStorageFiles = prefixedStorage.getItem(key);
    return localStorageFiles !== null ? parse(localStorageFiles) : [];
};

const getKeyByUserAndStudio = (
    userId: string,
    studioId?: string,
    isTemplate: boolean = false,
) => {
    const mainKey = isTemplate
        ? templateLocalStorageKey
        : produzioneLocalStorageKey;

    if (studioId) return `${mainKey}-${userId}-${studioId}`;
    return `${mainKey}-${userId}`;
};

/**
 * @param uuid
 */
const getDocumentoParsato: any | undefined = (uuid: string) => {
    const prefixedStorage = getLocalStorage();

    const localstorageDocument = prefixedStorage.getItem(uuid);
    return localstorageDocument !== null
        ? parse(localstorageDocument)
        : undefined;
};

export { setDocumenti, getDocumenti, overrideDocumenti, getDocumentoParsato };
